<template>
  <ACard id="password">
    <template #title>
      <span class="pwc__title">
        <i class="material-icons-round pwc__title-icon">lock</i>
        비밀번호 변경
      </span>
    </template>

    <div class="pwc__form">
      <div class="p-field">
        <label class="p-field__label">
          <i class="material-icons-round p-field__label-icon">lock</i>
          현재 비밀번호
        </label>
        <input v-model="passwordData.current" type="password" class="p-input" placeholder="••••••••" />
      </div>
      <div class="p-field">
        <label class="p-field__label">
          <i class="material-icons-round p-field__label-icon">lock_reset</i>
          새 비밀번호
        </label>
        <input v-model="passwordData.new" type="password" class="p-input" placeholder="••••••••" />
      </div>
      <div class="p-field">
        <label class="p-field__label">
          <i class="material-icons-round p-field__label-icon">check</i>
          비밀번호 확인
        </label>
        <input v-model="passwordData.confirm" type="password" class="p-input" placeholder="••••••••" />
      </div>
    </div>

    <div class="pwc__notice">
      <div class="pwc__notice-label">
        <i class="material-icons-round">info</i> 비밀번호 요구사항
      </div>
      <ul>
        <li>최소 1개의 특수문자 포함</li>
        <li>최소 8자 이상</li>
        <li>최소 1개의 숫자 포함 (2개 권장)</li>
        <li>정기적으로 변경하세요</li>
      </ul>
    </div>

    <template #foot>
      <ABtn kind="primary" icon="save" @click="updatePassword">비밀번호 업데이트</ABtn>
    </template>
  </ACard>
</template>

<script>
import ACard from "@/components/Pineapple/ACard.vue";
import ABtn from "@/components/Pineapple/ABtn.vue";

export default {
  name: "PasswordChangeCard",
  components: { ACard, ABtn },
  emits: ["update-password"],
  data() {
    return { passwordData: { current: "", new: "", confirm: "" } };
  },
  methods: {
    updatePassword() {
      if (!this.passwordData.current || !this.passwordData.new || !this.passwordData.confirm) {
        this.$notify({ type: "warn", text: "모든 필드를 입력해주세요." });
        return;
      }
      if (this.passwordData.new !== this.passwordData.confirm) {
        this.$notify({ type: "error", text: "새 비밀번호가 일치하지 않습니다." });
        return;
      }
      if (this.passwordData.new.length < 8) {
        this.$notify({ type: "error", text: "비밀번호는 최소 8자 이상이어야 합니다." });
        return;
      }
      this.$emit("update-password", this.passwordData);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.pwc {
  &__title {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 13px;
    font-weight: 800;
    color: $p-ink;
  }

  &__title-icon {
    color: $p-point-deep;
    font-size: 16px !important;
  }

  &__form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  &__notice {
    margin-top: 18px;
    padding: 14px 16px;
    background: $p-warn-soft;
    border-left: 3px solid $p-warn;
    border-radius: $p-radius-md;
  }

  &__notice-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.04em;
    color: $p-warn;
    margin-bottom: 8px;

    > i { font-size: 14px !important; }
  }

  ul {
    margin: 0;
    padding-left: 18px;
    font-size: 12px;
    color: $p-ink2;
    line-height: 1.7;
  }
}
</style>
